<fts-upsell-special-modal-content [upsellWrapper]="upsellWrapper"
                                  [upsellTriggerOrderableItem]="upsellTriggerOrderableItem"
                                  [upsellTriggerOrderedItem]="upsellTriggerOrderedItem"
                                  [upsellTriggerItemId]="upsellTriggerItemId"
                                  [menuItemsLayout]="menuItemsLayout"
                                  [editingItemContext]="editingContext"
                                  [skipNavigation]="skipNavigation"
                                  (makeCombo)="makeCombo($event)"
                                  (hideModal)="hideModal($event)"></fts-upsell-special-modal-content>
